import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { AgentsData } from '~/sections/loan-officers/profile/connections/types';

type IndexParams = {
  nmls: string;
  agent_type: string;
  page: number;
  period: Period;
  sort_field: string;
  order: Order;
};

type IndexResponse = {
  data: AgentsData;
};

export const index = async (allParams: IndexParams) => {
  const { nmls, sort_field, order, ...params } = allParams;
  return apiClient.get<IndexResponse>(
    `/loan_officers/${nmls}/realtors?sort[field]=${sort_field}&sort[order]=${order}`,
    { params }
  );
};
